/** Dashboard → Claims list: maps stable keys to ClaimTable file-status filter values. */
import {
  CLAIM_FILE_STATUS_CHART_LABELS,
  CLAIM_FILE_STATUS_CLOSED_PORTION,
  CLAIM_FILE_STATUS_OPEN_PORTION,
  CLAIM_PAYMENTS_OTHER_STATUSES,
} from 'data/constants/common_constants';

const CLAIM_STATUS_PREFILTER_MAP = {
  open_test_claim: { selectedFileStatus: [CLAIM_FILE_STATUS_CHART_LABELS.open_test_claim] },
  open_pending_decision: {
    selectedFileStatus: [CLAIM_FILE_STATUS_CHART_LABELS.open_pending_decision],
  },
  open_pending_payment: {
    selectedFileStatus: [CLAIM_FILE_STATUS_CHART_LABELS.open_pending_payment],
  },
  closed_denied: { selectedFileStatus: [CLAIM_FILE_STATUS_CHART_LABELS.closed_denied] },
  closed_paid: { selectedFileStatus: [CLAIM_FILE_STATUS_CHART_LABELS.closed_paid] },
  closed_incident_only: {
    selectedFileStatus: [CLAIM_FILE_STATUS_CHART_LABELS.closed_incident_only],
  },
  closed_partial_denial: { selectedFileStatus: ['Closed - Partial denial'] },
  closed_duplicate: { selectedFileStatus: [CLAIM_FILE_STATUS_CHART_LABELS.closed_duplicate] },
  closed_inactive: { selectedFileStatus: [CLAIM_FILE_STATUS_CHART_LABELS.closed_inactive] },
  incident_only: { selectedFileStatus: [CLAIM_FILE_STATUS_CHART_LABELS.incident_only] },
  claims_summary_open: { selectedFileStatus: [...CLAIM_FILE_STATUS_OPEN_PORTION] },
  claims_summary_closed: { selectedFileStatus: [...CLAIM_FILE_STATUS_CLOSED_PORTION] },
  claims_payment_closed_bucket: { selectedFileStatus: [...CLAIM_FILE_STATUS_CLOSED_PORTION] },
  claims_payment_other: { selectedFileStatus: [...CLAIM_PAYMENTS_OTHER_STATUSES] },
};

export const getClaimsDashboardPrefilter = (key) => {
  if (!key || typeof key !== 'string') return null;
  return CLAIM_STATUS_PREFILTER_MAP[key] || null;
};
